<template>
  <div v-if="this.linkPreviewData" class="link-preview">
    <img v-if="linkPreviewData.image" :src="linkPreviewData.image" class="img-best mr-2">
    <div>
      <div class="top">
        <img v-if="linkPreviewData.favicon" :src="linkPreviewData.favicon" class="img-favicon mr-2">
        <a :href="url" target="_blank" @click="requestAndSaveLinkPreviewData">{{ linkPreviewData.title }}</a>
      </div>
      <div class="bottom">{{ linkPreviewData.description }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LinkPreview',
  props: {
    url: String
  },
  data() {
    return {
      linkPreviewData: null
    }
  },
  methods: {
    async requestAndSaveLinkPreviewData() {
      this.linkPreviewData = await this.apiGetLinkPreview({
        link: this.url
      })
      if (this.linkPreviewData) {
        this.$dexieClient.linkPreviews.putWithExp({
          id: this.url,
          ...this.linkPreviewData
        })
      }
    },
    ...mapActions({
      apiGetLinkPreview: 'linkPreview/show',
    })
  },
  async created() {
    this.linkPreviewData = await this.$dexieClient.linkPreviews.get(this.url)
    if (!this.linkPreviewData) {
      this.requestAndSaveLinkPreviewData()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.link-preview {
  display: flex;
  border-top: 1px solid $light-border-color;
  padding: 10px 0;

  .img-best {
    width: 60px;
    height: 31.5px;
    object-fit: cover;
    object-position: center center;
    border-radius: 4px;
  }

  .img-favicon {
    width: 16px;
    height: 16px;
    border-radius: 4px;
  }

  .top {
    font-size: 12px;
    display: flex;
    align-items: center;
  }

  .bottom {
    font-size: 10px;
  }
}
</style>
